import { render, staticRenderFns } from "./konnFixedGrid.vue?vue&type=template&id=511649f5"
import script from "./konnFixedGrid.vue?vue&type=script&lang=js"
export * from "./konnFixedGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports